/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_OfferedInputs */

const en_us2_gallery_offered = /** @type {(inputs: Gallery_OfferedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent. The plan shows up in the gallery after review.`)
};

const pt_br2_gallery_offered = /** @type {(inputs: Gallery_OfferedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviado. O plano aparece na galeria depois da revisão.`)
};

const pt_pt2_gallery_offered = /** @type {(inputs: Gallery_OfferedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviado. O plano aparece na galeria depois da revisão.`)
};

/** @type {(inputs: Gallery_OfferedInputs) => LocalizedString} */
const es_419_gallery_offered = en_us2_gallery_offered;

/** @type {(inputs: Gallery_OfferedInputs) => LocalizedString} */
const fr_fr2_gallery_offered = en_us2_gallery_offered;

/** @type {(inputs: Gallery_OfferedInputs) => LocalizedString} */
const de_de2_gallery_offered = en_us2_gallery_offered;

/** @type {(inputs: Gallery_OfferedInputs) => LocalizedString} */
const it_it2_gallery_offered = en_us2_gallery_offered;

/**
* | output |
* | --- |
* | "Sent. The plan shows up in the gallery after review." |
*
* @param {Gallery_OfferedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gallery_offered = /** @type {((inputs?: Gallery_OfferedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_OfferedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gallery_offered(inputs)
	if (locale === "es-419") return es_419_gallery_offered(inputs)
	if (locale === "pt-PT") return pt_pt2_gallery_offered(inputs)
	if (locale === "fr-FR") return fr_fr2_gallery_offered(inputs)
	if (locale === "de-DE") return de_de2_gallery_offered(inputs)
	if (locale === "it-IT") return it_it2_gallery_offered(inputs)
	return en_us2_gallery_offered(inputs)
});
export { gallery_offered as "gallery.offered" }